import Api from '../utils/Api';
import Config from '../config/Config';

class DocumentoService {
  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntities([{ name: 'documentos' }]);
  }

  enviarDocumento(trackId, files, comentario, documentoFinal) {
    const config = { headers: { 'trackId': trackId } };
    const data = {
      'params': {
        'comentario': comentario,
        'documentos': files,
        'documentoFinal': documentoFinal
      }
    }
    return this.api.endpoints.documentos
      .create(data, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  enviarSolicitud(trackId, comentario) {
    const config = { headers: { 'trackId': trackId } };
    const bodyParam = {
      "params": {
        'comentario': comentario
      }
    }
    return this.api.endpoints.documentos
      .createWithAction('enviar', bodyParam, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

}

export default new DocumentoService;